import darkScrollbar from '@mui/material/darkScrollbar'
import { grey } from '@mui/material/colors'

const getDesignTokens = () => ({
  palette: {
    aliceBlue: '#F2F7FF',
    oxfordBlue: '#061551',
    violetsAreBlue: '#854EFF',
    apple: '#4CAF50',
    azureishWhite: '#D8E5FA',
    greenSheen: '#69B1AF ',
    grayX11: '#BDBDBD ',
    vodka: '#C8B1FC',
    lightSilver: '#D9D9D9',
    oriolesOrange: '#F4511E',
    mayGreen: '#43A047',
    brilliantAzure: '#3099FF',
    darkCyan: '#009688',
    davysGrey: '#585858',
    coralRed: '#F44336',
    cultured: '#F5F5F5',
    hanBlue: '#5672D9',
    folly: '#F50057',
    pictonBlue: '#4DABF5',
    deepLemon: '#FFCA18',
    congoPink: '#ff8a80',
    denimBlue: '#303AC4',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          ...darkScrollbar(
            {
              track: grey[200],
              thumb: grey[400],
              active: grey[400]
            }
          ),
          scrollbarWidth: 'thin',
        },
        div: {
          ...darkScrollbar(
            {
              track: grey[200],
              thumb: grey[400],
              active: grey[400]
            }
          ),
          scrollbarWidth: 'thin',
        }
      }
    }
  }
})

export default getDesignTokens